import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import { IconButton } from "@mui/material";

function Funders({ location, SetSelectedMenu }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [list, setList] = useState([]);
    const [id, setId] = useState();

    const [count, setCount] = useState(0);

    const [deleteOpen, setDeleteOpen] = useState(false);

    const history = useHistory();

    useEffect(() => {
        SetSelectedMenu({
            menu: "funder",
            title: "Funders Management",
        });
    }, []);

    const columns = [
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "representative",
            label: "Representative",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "address",
            label: "Address",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "phone",
            label: "Phone",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },

        {
            name: "projects",
            label: "Projects",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "totalFundedAmount",
            label: "Funded Amount",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },

        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <div className="flex items-center">


                        <IconButton onClick={() => {
                    history.push(`/admin/funder-projects/${v}`, {funder: list.find((x) => x.id === v)});
                        }}
                        >
                            <img
                                src={require("../../assets/icons/eye.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm text-blueGray-300"
                                }
                            />
                        </IconButton>
                        <IconButton onClick={() => {
                            setId(v);
                            setValue({
                                name: list.find((x) => x.id === v).name,
                                representative: list.find((x) => x.id === v).representative,
                                address: list.find((x) => x.id === v).address,
                                email: list.find((x) => x.id === v).email,
                                phone: list.find((x) => x.id === v).phone,
                                
                         
                            });
                            setOpen(2);
                        }}>
                            <img
                                src={require("../../assets/icons/pencil.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "

                                }
                            />
                        </IconButton>

                        {/* <IconButton onClick={() => { setId(v); setDeleteOpen(true) }}>
                            <img
                                src={require("../../assets/icons/trash.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "
                                }
                            />
                        </IconButton> */}

                    </div>
                ),
            },
        },
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">
            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/funder/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/funder/create" : `/api/funder/update/${id}`}
                title={open === 1 ? "Create New Funder" : "Edit Funder"}
                fields={[
                    {
                        name: "name",
                        label: "Funder name",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "representative",
                        label: "Representative",
                        value: value["representative"],
                        required: false,
                        type: 'text',
                        setValue: (val) => setValue0("representative", val),
                    },
                    {
                        name: "address",
                        label: "Address",
                        type: "text",
                        value: value["address"],
                        required: true,
                        setValue: (val) => setValue0("address", val),
                    },
                    {
                        name: "email",
                        label: "Email",
                        type: "text",
                        value: value["email"],
                        required: true,
                        setValue: (val) => setValue0("email", val),
                    },
                    {
                        name: "phone",
                        label: "Phone",
                        type: "text",
                        value: value["phone"],
                        required: true,
                        setValue: (val) => setValue0("phone", val),
                    },


                ]}
            />
            <DatatableComponent

                onAddNew={() => setOpen(1)}
                processData={(data) => {
                    setList(data.data);
                    return data;
                }}
                onRowClick={(data, { rowIndex })=> {
                    const info = list[rowIndex];
                    history.push(`/admin/funder-projects/${info?.id}`, {funder: info});
                    // history.push(`/admin/funder-projects/${data.id}`, {funder: data});
                }}
                onRowSelectionChange={(list) => {

                }
                }
                elevation={1}
                pdf={false}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                url={`/api/funder/list?count=${count}`}
                title={
                    "All Funders List"
                }
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Funders);
